import { render, staticRenderFns } from "./PfModal.vue?vue&type=template&id=7afdfb0e&"
import script from "./PfModal.vue?vue&type=script&lang=js&"
export * from "./PfModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports